import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../lib/services";

export const Services = () => {
  return (
    <section
      id="services"
      className="relative py-24 md:py-36 bg-[#F2F0EA]"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="uppercase text-xs tracking-[0.3em] text-sage mb-6">
              What we do
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-forest leading-[1.05] tracking-tight">
              One partner.
              <br />
              <span className="italic">Every</span> service your estate needs.
            </h2>
          </div>
          <p className="text-graphite text-base md:text-lg max-w-md leading-relaxed">
            From routine upkeep to emergency response, our certified teams deliver
            a complete spectrum of maintenance solutions — managed under one accountable roof.
          </p>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-px bg-bordersoft border border-bordersoft"
          data-testid="services-grid"
        >
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.slug}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: (i % 6) * 0.08 }}
                className={s.span || ""}
              >
                <Link
                  to={`/services/${s.slug}`}
                  className={`relative bg-cream p-8 md:p-10 group hover:bg-white transition-colors duration-500 block h-full`}
                  data-testid={`service-card-${s.slug}`}
                >
                  {s.image && (
                    <div className="relative w-full h-56 mb-8 overflow-hidden">
                      <img
                        src={s.image}
                        alt={s.title}
                        className="w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                      />
                    </div>
                  )}
                  <div className="flex items-start justify-between mb-6">
                    <Icon
                      size={32}
                      strokeWidth={1.25}
                      className="text-forest group-hover:text-gold transition-colors duration-500"
                    />
                    <span className="font-serif text-sage/40 text-2xl">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="font-serif text-2xl md:text-3xl text-ink leading-tight mb-3">
                    {s.title}
                  </h3>
                  <p className="text-graphite text-sm md:text-base leading-relaxed mb-6">
                    {s.short}
                  </p>
                  <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-forest group-hover:text-gold transition-colors">
                    Read more <ArrowUpRight size={14} />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href="#contact"
            data-testid="services-cta"
            className="inline-flex items-center gap-3 border border-forest text-forest px-7 py-4 text-sm tracking-wider hover:bg-forest hover:text-cream transition-colors duration-300"
          >
            Discuss your estate's needs
            <span aria-hidden>→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
